import artistFrag from "./Artist";
import artworkCategory from "./ArtworkCategory";
import Country from "./Country";
import editionFrag from "./Edition";
import imageFrag from "./Image";

// TODO: look into images and imagesSummary
const Artwork = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    artists = false,
    countryOfOrigin = false,
    editions = false,
    images = true,
    imagesSummary = false,
    archiveDescription = includeDefaults,
    artistDescription = includeDefaults,
    artFair = includeDefaults,
    authenticity = includeDefaults,
    categoryId = includeDefaults,
    classId = includeDefaults,
    confidential = includeDefaults,
    countryOfOriginId = includeDefaults,
    createdAt = includeDefaults,
    description = includeDefaults,
    dimensions = includeDefaults,
    fullDescription = includeDefaults,
    goodsCode = includeDefaults,
    installation = includeDefaults,
    installationLink = includeDefaults,
    instanceReference = true, // artworks in image lists need this field
    maintenance = includeDefaults,
    medium = includeDefaults,
    packing = includeDefaults,
    photographed = includeDefaults,
    photoLink = includeDefaults,
    photoNote = includeDefaults,
    precis = includeDefaults,
    pressDescription = includeDefaults,
    reference = includeDefaults,
    series = includeDefaults,
    standardId = includeDefaults,
    technicalDimensions = includeDefaults,
    timestamp = includeDefaults,
    title = includeDefaults,
    travelPack = includeDefaults,
    videoLink = includeDefaults,
    website = includeDefaults,
  } = propsObj;

  return `
  id
  ${archiveDescription ? `archiveDescription` : ""}
  ${artFair ? `artFair` : ""}
  ${
    artists
      ? `artists {
      ${artistFrag(artists)}
    }`
      : ""
  }
  ${artistDescription ? `artistDescription` : ""}
  ${artworkCategory ? `artworkCategory {
    ${artworkCategory}
  }` : ""}
  ${authenticity ? `authenticity` : ""}
  ${categoryId ? `categoryId` : ""}
  ${classId ? `classId` : ""}
  ${confidential ? `confidential` : ""}
  ${
    countryOfOrigin
      ? `countryOfOrigin {
      ${Country}
    }`
      : ""
  }
  ${countryOfOriginId ? `countryOfOriginId` : ""}
  ${createdAt ? `createdAt` : ""}
  ${description ? `description` : ""}
  ${dimensions ? `dimensions` : ""}
  ${
    editions
      ? `editions {
      ${editionFrag(editions)}
    }`
      : ""
  }
  ${fullDescription ? `fullDescription` : ""}
  ${pressDescription ? `pressDescription` : ""}
  ${goodsCode ? `goodsCode` : ""}
  ${installation ? `installation` : ""}
  ${installationLink ? `installationLink` : ""}
  ${instanceReference ? `instanceReference` : ""}
  ${
    images
      ? `images {
      ${imageFrag(images)}
    }`
      : ""
  }
  ${
    imagesSummary
      ? `imagesSummary {
      ${imageFrag(imagesSummary)}
    }`
      : ""
  }
  ${maintenance ? `maintenance` : ""}
  ${medium ? `medium` : ""}
  ${packing ? `packing` : ""}
  ${photographed ? `photographed` : ""}
  ${photoLink ? `photoLink` : ""}
  ${photoNote ? `photoNote` : ""}
  ${precis ? `precis` : ""}
  ${reference ? `reference` : ""}
  ${series ? `series` : ""}
  ${standardId ? `standardId` : ""}
  ${technicalDimensions ? `technicalDimensions` : ""}
  ${timestamp ? `timestamp` : ""}
  ${title ? `title` : ""}
  ${travelPack ? `travelPack` : ""}
  ${videoLink ? `videoLink` : ""}
  ${website ? `website` : ""}
`;
};

export default Artwork;
